import GetLoading from "../../share/getLoading";
// import { useEffect, useState } from "react";
// import {
//   PlusCircleOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   UsergroupAddOutlined,
//   EditFilled,
//   DeleteFilled,
// } from "@ant-design/icons";
// import {
//   Pagination,
//   Modal,
//   Button,
//   Form,
//   Input,
//   Item,
//   UserOutlined,
//   Select,
//   Space,
//   Tag,
//   Checkbox,
//   Spin,
// } from "antd";
// import "../../styles/Home-module.css";
// import styles from "../../styles/Font.css";
// import { request } from "../../share/request";
// import Table from "react-bootstrap/Table";
// import { Stack } from "react-bootstrap";

// import { openNotification } from "../../share/message";

// import { getCurrentUser, getPermission } from "../../share/getProfile";
// import { getTageStyle } from "../../share/getStatusContent";
// import { formateDateClientTime, formateDateSystem } from "../../share/helper";
// import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

// const { Option } = Select;
// const SkillPage = () => {
//   const getProfileOrg = getCurrentUser();
//   const [list, setList] = useState([]);
//   const [UserID, setUserID] = useState("");
//   const [UserSkill_kh, setUserSkillKhmer] = useState("");
//   const [UserSkill_eng, setUserSkillEnglish] = useState("");
//   const [UserOther, setUserOther] = useState("");

//   const [loading, setLoading] = useState(true);
//   const [loadingSpin, setLoadingSpin] = useState(false);

//   const [TotalRecords, setTotalRecords] = useState();
//   const [TotalPage, setTotalPages] = useState();
//   const [PageNumber, setPageNumber] = useState(1);
//   const [Price, setPrice] = useState(0);
//   const [objFilter, setObjFilter] = useState({
//     page: 1,
//     search_skill_kh: "",
//     org_code: getProfileOrg.org_code,
//   });
//   useEffect(() => {
//     // block form load
//     getList(objFilter);
//   }, []);
//   // -----------------  permisstion page --------------------
//   const userPermission = getPermission();
//   const SkillPageValue = userPermission.find(
//     (permission) => permission.pagename === "skillpage"
//   ) || { add: 0, edit: 0, deleted: 0 };
//   const {
//     add: addvalue,
//     edit: Editvalue,
//     deleted: deletevalue,
//   } = SkillPageValue;
//   // -----------------  end permisstion page --------------------

//   const getList = async (objFilter) => {
//     try {
//       // Define query parameters, including page and search skill if provided
//       const params = new URLSearchParams({
//         page: objFilter.page,
//         search_skill_kh: objFilter.search_skill_kh || "",
//         org_code: objFilter.org_code,
//       });
//       console.log("Query", params.toString());

//       await new Promise((resolve) => setTimeout(resolve, 400)); // Optional delay for loading effect

//       // Send request with query parameters
//       const res = await request(`skill?${params.toString()}`, "get", {});

//       // Check and set response data
//       console.log("Response Data:", res);
//       if (res) {
//         console.log("Skills Length:", res.API_Server_ListSkill.length);
//         setList(res.API_Server_ListSkill);
//         setTotalPages(res.total_pages);
//         setTotalRecords(res.total_records);
//         setCurrentPage(res.page);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   //-------------- page management ----------------------
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

//   //-------------------------------------------

//   // ----------------- open modle ----------
//   const [visableModelDelete, setVisableModeleDelete] = useState(false);
//   const onDeleteModel = (item) => {
//     setUserID(item.id);
//     setUserSkillEnglish(item.skill_kh);
//     setVisableModeleDelete(true);
//   };
//   const onCLoseModelDelete = () => {
//     setVisableModeleDelete(false);
//   };
//   const onComfirmModelDelete = async () => {
//     console.log("ID delete is : " + UserID);
//     const res = await request("skill/" + UserID, "delete", {});
//     setVisableModeleDelete(false);
//     if (res) {
//       getList(objFilter);
//       setLoadingSpin(true);
//       await new Promise((resolve) => setTimeout(resolve, 400));
//       openNotification("success", "Success", "Delete Success !");
//     } else {
//       alert("Error!");
//     }
//     setLoadingSpin(false);
//   };
//   // --------------- end model delete--------

//   //---------------- statuse --------------
//   const getStatusStyle = (status) => {
//     switch (status) {
//       case 1:
//         return (
//           <Button
//             type="primary"
//             ghost
//             shape="round"
//             icon={<CheckCircleOutlined />}
//           >
//             {" "}
//             Enable{" "}
//           </Button>
//         );
//       case 0:
//         return (
//           <Button
//             type="primary"
//             danger
//             ghost
//             shape="round"
//             icon={<ClockCircleOutlined />}
//           >
//             {" "}
//             Disable{" "}
//           </Button>
//         );

//       default:
//         return null;
//     }
//   };
//   // ------------- end status----------

//   //---------------------------

//   //------------- save ----------
//   const [visableNewModel, setVisableNewModel] = useState(false);
//   const onOpenSaveNew = () => {
//     setUserID("");
//     console.log("user id " + UserID);
//     setUserSkillKhmer("");
//     setUserSkillEnglish("");
//     setUserOther("");
//     setPrice(0);
//     setVisableNewModel(true);
//     setEnable(true);
//     setDisable(false);
//   };
//   const onCLoseNewDataModel = () => {
//     setVisableNewModel(false);
//   };
//   //-------------   enable and disable ---------------

//   const [enable, setEnable] = useState(false);
//   const [disable, setDisable] = useState(false);
//   const handleCheckboxChange_Enable = (e) => {
//     setEnable(e.target.checked);
//     setDisable(false);
//   };
//   const handleCheckboxChange_Diable = (e) => {
//     setDisable(e.target.checked);
//     setEnable(false);
//   };
//   //--------------------------------------------

//   //------------------- save data to position--------

//   //   const [status,setStatus]=useState(1);
//   const onSaveData = async () => {
//     if (UserID == "") {
//       var data = {
//         skill_kh: UserSkill_kh,
//         skill_eng: UserSkill_eng,
//         create_by: getProfileOrg.fullname,
//         create_date: formateDateClientTime(Date.now()),
//         status: enable == true ? 1 : disable == true ? 0 : 0,
//         other: UserOther,
//         price: Price,
//         org_code: getProfileOrg.org_code,
//       };
//       const res = request("skill", "post", data);
//       setVisableNewModel(false);
//       if (res) {
//         setLoadingSpin(true);
//         await new Promise((resolve) => setTimeout(resolve, 400));
//         openNotification("success", "Success", "Save  Success");
//       } else {
//         alert("Error!");
//       }
//       getList(objFilter); // re call function list
//       setLoadingSpin(false);
//     } else {
//       var data = {
//         id: UserID,
//         skill_kh: UserSkill_kh,
//         skill_eng: UserSkill_eng,
//         create_date: formateDateClientTime(Date.now()),
//         create_by: getProfileOrg.fullname,
//         status: enable == true ? 1 : disable == true ? 0 : 0,
//         other: UserOther,
//         price: Price,
//         org_code: getProfileOrg.org_code,
//       };
//       const res = request("skill", "put", data);
//       setVisableNewModel(false);
//       if (res) {
//         setLoadingSpin(true);
//         await new Promise((resolve) => setTimeout(resolve, 400));
//         openNotification("success", "Success", "Update  Success");
//       } else {
//         alert("Error!");
//       }
//       getList(objFilter); // re call function list
//       setLoadingSpin(false);
//     }
//   };

//   const onChangeKH = (event) => {
//     setUserSkillKhmer(event.target.value);
//   };
//   const onChangeEN = (event) => {
//     setUserSkillEnglish(event.target.value);
//   };
//   const onChangeOther = (event) => {
//     setUserOther(event.target.value);
//   };
//   const onChangePrice = (event) => {
//     setPrice(event.target.value);
//   };

//   //--------------------

//   //--------------- Eidt data ----------
//   const onOpenEdit = (item) => {
//     setUserID(item.id);
//     setUserSkillKhmer(item.skill_kh);
//     setUserSkillEnglish(item.skill_eng);
//     setUserOther(item.other);
//     setPrice(item.price);
//     setVisableNewModel(true);

//     if (item.status === 1) {
//       return setEnable(true), setDisable(false);
//     } else {
//       return setEnable(false), setDisable(true);
//     }
//   };

//   //-------------------------
//   const onCancelModel = () => {
//     setVisableNewModel(false);
//   };
//   const onCanceDelete = () => {
//     setVisableModeleDelete(false);
//   };

//   const onShowSizeChange = (current) => {
//     console.log(current);
//     setPageNumber(current);

//     var objTmp = {
//       ...objFilter,
//       page: current,
//     };
//     setObjFilter(objTmp);
//     getList(objTmp);
//   };
//   const OnSearchText = (value) => {
//     setCurrentPage(1); // Reset to page 1 on search
//     try {
//       var objTmp = {
//         ...objFilter,
//         search_skill_kh: value.target.value, // Set the department name
//         page: value.target.value === "" ? 1 : objFilter.page, // Set page to 1 if input is empty, otherwise retain current page
//       };
//       setObjFilter(objTmp); // Update the filter state
//       getList(objTmp); // Fetch the updated list
//     } catch (error) {
//       console.error("Error in OnSearchText:", error); // Log any errors
//     }
//   };
//   return (
//     <div>
//       <div className="sprinSave-container">
//         {/* Your other components */}
//         {loadingSpin && (
//           <div className="sprinSave">
//             <GetLoading />
//           </div>
//         )}
//       </div>

//       <div style={boxHeader}>
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           {boxHeaderTagText("ការគ្រប់គ្រង់ ជំនាញផ្សេងៗ")}
//           <Input
//             style={{ width: "auto" }}
//             placeholder="Search..."
//             onChange={OnSearchText}
//             allowClear
//           />
//         </div>
//         <Button
//           onClick={onOpenSaveNew}
//           disabled={!addvalue}
//           className="custom-form-item"
//           type="primary"
//           icon={<PlusCircleOutlined />}
//         >
//           បន្ថែមថ្មី
//         </Button>
//       </div>

//       <div>
//         {loading ? (
//           <div className="sprinCustome">
//             <GetLoading />
//           </div>
//         ) : (
//           <Table
//             // striped
//             // bordered
//             // hover
//             className="rounded-table"
//             itemsPerPage={10}
//           >
//             <thead>
//               <tr class="table-success">
//                 <th>NO</th>
//                 <th>ជំនាញផ្សេងៗ </th>
//                 <th>ជំនាញ English</th>
//                 <th>ថ្ងៃបង្កើត</th>
//                 <th>អ្នកបង្កើត</th>
//                 <th>ស្ថានភាព</th>
//                 <th>ផ្សេងៗ</th>
//                 <th>តម្លៃវេនយាម</th>
//                 <th>សកម្មភាព</th>
//               </tr>
//             </thead>
//             <tbody>
//               {list.map((item, index) => (
//                 <tr key={index}>
//                   <td>{10 * (PageNumber - 1) + (index + 1)}</td>
//                   <td>{item.skill_kh}</td>
//                   <td>{item.skill_eng}</td>
//                   <td>{formateDateClientTime(item.create_date)}</td>
//                   <td> {getTageStyle(item.create_by)}</td>
//                   <td>{getStatusStyle(item.status)}</td>
//                   <td>{item.other}</td>
//                   <td>{item.price.toLocaleString()} ៛</td>
//                   <td style={{ width: 100 }}>
//                     <Stack gap={1} direction="horizontal">
//                       <Button
//                         icon ={<EditFilled />}
//                         disabled={!Editvalue}
//                         type="primary"
//                         onClick={() => onOpenEdit(item)}
//                       >
                         
//                       </Button>{" "}
//                       <Button
//                        icon ={<DeleteFilled />}
//                         disabled={!deletevalue}
//                         type="primary"
//                         onClick={() => onDeleteModel(item)}
//                         danger
//                       >
                         
//                       </Button>
//                     </Stack>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         )}

//         <Pagination
//           //   showSizeChanger
//           onChange={onShowSizeChange}
//           defaultCurrent={PageNumber}
//           total={TotalRecords}
//         />

//         <Modal
//           title={UserID == "" ? "New Skill" : "Update Skill"}
//           className="styleTageStatusForm"
//           open={visableNewModel}
//           onCancel={onCancelModel}
//           footer={[
//             <div>
//               <Space>
//                 <Button onClick={onCLoseNewDataModel}>Cancel</Button>
//                 <Button type="primary" onClick={onSaveData}>
//                   {UserID == "" ? "Save" : "Update"}
//                 </Button>
//               </Space>
//             </div>,
//           ]}
//         >
//           <div style={{ display: "flex", justifyContent: "start" }}>
//             <div>
//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ឈ្មោះជំនាញ / Skill in Khmer
//               </p>
//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={2}
//                 placeholder="input other"
//                 value={UserSkill_kh}
//                 onChange={onChangeKH}
//                 style={{ width: 250 }}
//               />

//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ឈ្មោះជំនាញ / English
//               </p>

//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={2}
//                 placeholder="input other"
//                 value={UserSkill_eng}
//                 onChange={onChangeEN}
//                 style={{ width: 250 }}
//               />

//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ផ្សេងៗ / Other
//               </p>
//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={4}
//                 placeholder="input other"
//                 value={UserOther}
//                 onChange={onChangeOther}
//                 style={{ width: 250 }}
//               />
//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 តម្លៃវេនយាម / Price
//               </p>
//               <Input.TextArea
//                 className="styleTageStatusForm"
//                 rows={2}
//                 placeholder="បញ្ចូលតម្លៃវេនយាម"
//                 value={Price}
//                 onChange={onChangePrice}
//                 style={{ width: 250 }}
//               />
//             </div>

//             <div style={{ paddingLeft: 20 }}>
//               <p
//                 style={{
//                   margin: 5,
//                   color: "darkgray",
//                   paddingTop: 10,
//                   fontFamily: 'Content',
//                 }}
//               >
//                 ស្ថានភាព / Status
//               </p>

//               <Tag>
//                 {" "}
//                 <div style={{ padding: 10 }}>
//                   <Checkbox
//                     checked={enable}
//                     onChange={handleCheckboxChange_Enable}
//                   >
//                     Enable
//                   </Checkbox>
//                   <Checkbox
//                     style={{ color: "red" }}
//                     checked={disable}
//                     onChange={handleCheckboxChange_Diable}
//                   >
//                     Disable
//                   </Checkbox>
//                 </div>
//               </Tag>
//             </div>
//           </div>
//         </Modal>

//         <Modal
//           title="លុបជំនាញ "
//           className="custom-form-item"
//           open={visableModelDelete}
//           onCancel={onCanceDelete}
//           footer={[
//             <div>
//               <Button onClick={onCLoseModelDelete}>No</Button>
//               <Button onClick={onComfirmModelDelete} type="primary">
//                 Yes
//               </Button>
//             </div>,
//           ]}
//         >
//           <p className="custom-form-item" style={{ color: "red" }}>
//             តើអ្នកចង់លុបជំនាញ ៖ {UserSkill_kh} នេះចេញពីប្រព័ន្ធ ?
//           </p>
//         </Modal>
//       </div>
//     </div>
//   );
// };

// export default SkillPage;



import { useEffect, useState } from "react";
import {
  PlusCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  UsergroupAddOutlined,
  EditFilled,
  DeleteFilled,
  ExclamationCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import {
  Pagination,
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Tag,
  Checkbox,
  Alert,
} from "antd";
import "../../styles/Home-module.css";
import styles from "../../styles/Font.css";
import { request } from "../../share/request";
import Table from "react-bootstrap/Table";
import { Stack } from "react-bootstrap";

import { openNotification } from "../../share/message";
import { getCurrentUser, getPermission } from "../../share/getProfile";
import { getTageStyle } from "../../share/getStatusContent";
import { formateDateClientTime, formateDateSystem } from "../../share/helper";

import { boxHeader, boxHeaderTagText } from "../../styles/boxShadow";

const { Option } = Select;

const SkillPage = () => {
  const getProfileOrg = getCurrentUser();
  const [list, setList] = useState([]);
  const [UserID, setUserID] = useState("");
  const [UserSkill_kh, setUserSkillKhmer] = useState("");
  const [UserSkill_eng, setUserSkillEnglish] = useState("");
  const [UserOther, setUserOther] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingSpin, setLoadingSpin] = useState(false);

  const [TotalRecords, setTotalRecords] = useState();
  const [TotalPage, setTotalPages] = useState();
  const [PageNumber, setPageNumber] = useState(1);
  const [Price, setPrice] = useState(0);
  
  // Delete confirmation states
  const [confirmText, setConfirmText] = useState("");
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
  const [deleteSkillName, setDeleteSkillName] = useState("");
  const CONFIRM_WORD = "SKILL";

  const [objFilter, setObjFilter] = useState({
    page: 1,
    search_skill_kh: "",
    org_code: getProfileOrg.org_code,
  });

  useEffect(() => {
    getList(objFilter);
  }, []);

  // -----------------  permisstion page --------------------
  const userPermission = getPermission();
  const SkillPageValue = userPermission.find(
    (permission) => permission.pagename === "skillpage"
  ) || { add: 0, edit: 0, deleted: 0 };
  const {
    add: addvalue,
    edit: Editvalue,
    deleted: deletevalue,
  } = SkillPageValue;
  // -----------------  end permisstion page --------------------

  const getList = async (objFilter) => {
    try {
      const params = new URLSearchParams({
        page: objFilter.page,
        search_skill_kh: objFilter.search_skill_kh || "",
        org_code: objFilter.org_code,
      });
      console.log("Query", params.toString());

      await new Promise((resolve) => setTimeout(resolve, 400));

      const res = await request(`skill?${params.toString()}`, "get", {});
      console.log("Response Data:", res);
      if (res) {
        console.log("Skills Length:", res.API_Server_ListSkill.length);
        setList(res.API_Server_ListSkill);
        setTotalPages(res.total_pages);
        setTotalRecords(res.total_records);
        setCurrentPage(res.page);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  //-------------- page management ----------------------
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = list.slice(indexOfFirstItem, indexOfLastItem);

  //-------------------------------------------

  // ----------------- open modle ----------
  const [visableModelDelete, setVisableModeleDelete] = useState(false);
  
  const onDeleteModel = (item) => {
    setUserID(item.id);
    setDeleteSkillName(item.skill_kh);
    setVisableModeleDelete(true);
    // Reset confirmation state
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  const onCLoseModelDelete = () => {
    setVisableModeleDelete(false);
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  // Handle confirm text input change
  const handleConfirmTextChange = (e) => {
    const value = e.target.value;
    setConfirmText(value);
    setIsConfirmDisabled(value !== CONFIRM_WORD);
  };

  const onComfirmModelDelete = async () => {
    if (confirmText !== CONFIRM_WORD) {
      openNotification("warning", "Warning", `Please type "${CONFIRM_WORD}" to confirm deletion`);
      return;
    }

    console.log("ID delete is : " + UserID);
    setLoadingSpin(true);
    try {
      const res = await request("skill/" + UserID, "delete", {});
      setVisableModeleDelete(false);
      setConfirmText("");
      setIsConfirmDisabled(true);
      if (res) {
        getList(objFilter);
        await new Promise((resolve) => setTimeout(resolve, 400));
        openNotification("success", "Success", "Delete Success!");
      } else {
        openNotification("error", "Error", "Delete failed!");
      }
    } catch (error) {
      console.error("Error deleting:", error);
      openNotification("error", "Error", "An error occurred while deleting");
    } finally {
      setLoadingSpin(false);
    }
  };
  // --------------- end model delete--------

  //---------------- statuse --------------
  const getStatusStyle = (status) => {
    switch (status) {
      case 1:
        return (
          <Button
            type="primary"
            ghost
            shape="round"
            icon={<CheckCircleOutlined />}
          >
            Enable
          </Button>
        );
      case 0:
        return (
          <Button
            type="primary"
            danger
            ghost
            shape="round"
            icon={<ClockCircleOutlined />}
          >
            Disable
          </Button>
        );
      default:
        return null;
    }
  };
  // ------------- end status----------

  //------------- save ----------
  const [visableNewModel, setVisableNewModel] = useState(false);
  const onOpenSaveNew = () => {
    setUserID("");
    console.log("user id " + UserID);
    setUserSkillKhmer("");
    setUserSkillEnglish("");
    setUserOther("");
    setPrice(0);
    setVisableNewModel(true);
    setEnable(true);
    setDisable(false);
  };
  const onCLoseNewDataModel = () => {
    setVisableNewModel(false);
  };

  //-------------   enable and disable ---------------
  const [enable, setEnable] = useState(false);
  const [disable, setDisable] = useState(false);
  const handleCheckboxChange_Enable = (e) => {
    setEnable(e.target.checked);
    setDisable(false);
  };
  const handleCheckboxChange_Diable = (e) => {
    setDisable(e.target.checked);
    setEnable(false);
  };
  //--------------------------------------------

  //------------------- save data to position--------
  const onSaveData = async () => {
    setLoadingSpin(true);
    try {
      if (UserID === "") {
        var data = {
          skill_kh: UserSkill_kh,
          skill_eng: UserSkill_eng,
          create_by: getProfileOrg.fullname,
          create_date: formateDateClientTime(Date.now()),
          status: enable === true ? 1 : disable === true ? 0 : 0,
          other: UserOther,
          price: Price,
          org_code: getProfileOrg.org_code,
        };
        const res = await request("skill", "post", data);
        setVisableNewModel(false);
        if (res) {
          await new Promise((resolve) => setTimeout(resolve, 400));
          openNotification("success", "Success", "Save Success");
        } else {
          openNotification("error", "Error", "Save failed!");
        }
      } else {
        var data = {
          id: UserID,
          skill_kh: UserSkill_kh,
          skill_eng: UserSkill_eng,
          create_date: formateDateClientTime(Date.now()),
          create_by: getProfileOrg.fullname,
          status: enable === true ? 1 : disable === true ? 0 : 0,
          other: UserOther,
          price: Price,
          org_code: getProfileOrg.org_code,
        };
        const res = await request("skill", "put", data);
        setVisableNewModel(false);
        if (res) {
          await new Promise((resolve) => setTimeout(resolve, 400));
          openNotification("success", "Success", "Update Success");
        } else {
          openNotification("error", "Error", "Update failed!");
        }
      }
      getList(objFilter);
    } catch (error) {
      console.error("Error saving:", error);
      openNotification("error", "Error", "An error occurred");
    } finally {
      setLoadingSpin(false);
    }
  };

  const onChangeKH = (event) => {
    setUserSkillKhmer(event.target.value);
  };
  const onChangeEN = (event) => {
    setUserSkillEnglish(event.target.value);
  };
  const onChangeOther = (event) => {
    setUserOther(event.target.value);
  };
  const onChangePrice = (event) => {
    setPrice(event.target.value);
  };

  //--------------- Eidt data ----------
  const onOpenEdit = (item) => {
    setUserID(item.id);
    setUserSkillKhmer(item.skill_kh);
    setUserSkillEnglish(item.skill_eng);
    setUserOther(item.other);
    setPrice(item.price);
    setVisableNewModel(true);

    if (item.status === 1) {
      setEnable(true);
      setDisable(false);
    } else {
      setEnable(false);
      setDisable(true);
    }
  };

  //-------------------------
  const onCancelModel = () => {
    setVisableNewModel(false);
  };
  const onCanceDelete = () => {
    setVisableModeleDelete(false);
    setConfirmText("");
    setIsConfirmDisabled(true);
  };

  const onShowSizeChange = (current) => {
    console.log(current);
    setPageNumber(current);

    var objTmp = {
      ...objFilter,
      page: current,
    };
    setObjFilter(objTmp);
    getList(objTmp);
  };

  const OnSearchText = (value) => {
    setCurrentPage(1);
    try {
      var objTmp = {
        ...objFilter,
        search_skill_kh: value.target.value,
        page: value.target.value === "" ? 1 : objFilter.page,
      };
      setObjFilter(objTmp);
      getList(objTmp);
    } catch (error) {
      console.error("Error in OnSearchText:", error);
    }
  };

  return (
    <div>
      <div className="sprinSave-container">
        {loadingSpin && (
          <div className="sprinSave">
            <GetLoading />
          </div>
        )}
      </div>

      <div style={boxHeader}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {boxHeaderTagText("ការគ្រប់គ្រង់ ជំនាញផ្សេងៗ")}
          <Input
            style={{ width: "auto" }}
            placeholder="Search..."
            onChange={OnSearchText}
            allowClear
          />
        </div>
        <Button
          onClick={onOpenSaveNew}
          disabled={!addvalue}
          className="custom-form-item"
          type="primary"
          icon={<PlusCircleOutlined />}
        >
          បន្ថែមថ្មី
        </Button>
      </div>

      <div>
        {loading ? (
          <div className="sprinCustome">
            <GetLoading />
          </div>
        ) : (
          <Table className="rounded-table" itemsPerPage={10}>
            <thead>
              <tr className="table-success">
                <th>NO</th>
                <th>ជំនាញផ្សេងៗ</th>
                <th>ជំនាញ English</th>
                <th>ថ្ងៃបង្កើត</th>
                <th>អ្នកបង្កើត</th>
                <th>ស្ថានភាព</th>
                <th>ផ្សេងៗ</th>
                <th>តម្លៃវេនយាម</th>
                <th>សកម្មភាព</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={index}>
                  <td>{10 * (PageNumber - 1) + (index + 1)}</td>
                  <td>{item.skill_kh}</td>
                  <td>{item.skill_eng}</td>
                  <td>{formateDateClientTime(item.create_date)}</td>
                  <td>{getTageStyle(item.create_by)}</td>
                  <td>{getStatusStyle(item.status)}</td>
                  <td>{item.other}</td>
                  <td>{item.price ? item.price.toLocaleString() : 0} ៛</td>
                  <td style={{ width: 100 }}>
                    <Stack gap={1} direction="horizontal">
                      <Button
                        icon={<EditFilled />}
                        disabled={!Editvalue}
                        type="primary"
                        onClick={() => onOpenEdit(item)}
                      />
                      <Button
                        icon={<DeleteFilled />}
                        disabled={!deletevalue}
                        type="primary"
                        onClick={() => onDeleteModel(item)}
                        danger
                      />
                    </Stack>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <Pagination
          onChange={onShowSizeChange}
          defaultCurrent={PageNumber}
          total={TotalRecords}
        />

        {/* New/Edit Skill Modal */}
        <Modal
          title={UserID === "" ? "New Skill" : "Update Skill"}
          className="styleTageStatusForm"
          open={visableNewModel}
          onCancel={onCancelModel}
          footer={[
            <div key="footer">
              <Space>
                <Button onClick={onCLoseNewDataModel}>Cancel</Button>
                <Button type="primary" onClick={onSaveData} loading={loadingSpin}>
                  {UserID === "" ? "Save" : "Update"}
                </Button>
              </Space>
            </div>,
          ]}
        >
          <div style={{ display: "flex", justifyContent: "start" }}>
            <div>
              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ឈ្មោះជំនាញ / Skill in Khmer
              </p>
              <Input.TextArea
                className="styleTageStatusForm"
                rows={2}
                placeholder="Input skill in Khmer"
                value={UserSkill_kh}
                onChange={onChangeKH}
                style={{ width: 250 }}
              />

              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ឈ្មោះជំនាញ / English
              </p>

              <Input.TextArea
                className="styleTageStatusForm"
                rows={2}
                placeholder="Input skill in English"
                value={UserSkill_eng}
                onChange={onChangeEN}
                style={{ width: 250 }}
              />

              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ផ្សេងៗ / Other
              </p>
              <Input.TextArea
                className="styleTageStatusForm"
                rows={4}
                placeholder="Input other details"
                value={UserOther}
                onChange={onChangeOther}
                style={{ width: 250 }}
              />
              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                តម្លៃវេនយាម / Price
              </p>
              <Input.TextArea
                className="styleTageStatusForm"
                rows={2}
                placeholder="បញ្ចូលតម្លៃវេនយាម"
                value={Price}
                onChange={onChangePrice}
                style={{ width: 250 }}
              />
            </div>

            <div style={{ paddingLeft: 20 }}>
              <p
                style={{
                  margin: 5,
                  color: "darkgray",
                  paddingTop: 10,
                  fontFamily: 'Content',
                }}
              >
                ស្ថានភាព / Status
              </p>

              <Tag>
                <div style={{ padding: 10 }}>
                  <Checkbox
                    checked={enable}
                    onChange={handleCheckboxChange_Enable}
                  >
                    Enable
                  </Checkbox>
                  <Checkbox
                    style={{ color: "red" }}
                    checked={disable}
                    onChange={handleCheckboxChange_Diable}
                  >
                    Disable
                  </Checkbox>
                </div>
              </Tag>
            </div>
          </div>
        </Modal>

        {/* Delete Confirmation Modal with Type-to-Confirm */}
        <Modal
          title={
            <Space>
              <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: '20px' }} />
              <span style={{ color: '#ff4d4f' }}>Confirm Deletion</span>
            </Space>
          }
          className="custom-form-item"
          open={visableModelDelete}
          onCancel={onCanceDelete}
          footer={[
            <div key="delete-footer" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Button onClick={onCLoseModelDelete}>Cancel</Button>
              <Button 
                onClick={onComfirmModelDelete} 
                type="primary" 
                danger
                disabled={isConfirmDisabled}
                icon={<DeleteFilled />}
                loading={loadingSpin}
              >
                Delete Skill
              </Button>
            </div>,
          ]}
          width={520}
        >
          <div style={{ padding: '16px 0' }}>
            <Alert
              message="Warning"
              description={
                <span>
                  This action <strong>cannot be undone</strong>. This will permanently delete the skill.
                </span>
              }
              type="warning"
              showIcon
              icon={<WarningOutlined />}
              style={{ marginBottom: 20 }}
            />
            
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              borderRadius: 8, 
              padding: '12px 16px',
              marginBottom: 20 
            }}>
              <p style={{ margin: 0, color: '#333', fontSize: 14, fontFamily: 'Content' }}>
                តើអ្នកចង់លុបជំនាញ <strong style={{ color: '#ff4d4f' }}>"{deleteSkillName}"</strong> នេះចេញពីប្រព័ន្ធ ?
              </p>
            </div>

            <div style={{ 
              background: '#fafafa', 
              border: '1px solid #d9d9d9', 
              borderRadius: 8, 
              padding: '16px',
            }}>
              <p style={{ 
                margin: '0 0 8px 0', 
                fontSize: 13, 
                color: '#666',
                fontWeight: 500 
              }}>
                Please type <strong style={{ 
                  color: '#ff4d4f', 
                  background: '#fff2f0', 
                  padding: '2px 8px', 
                  borderRadius: 4,
                  fontFamily: 'monospace',
                  fontSize: 14,
                  letterSpacing: 2
                }}>{CONFIRM_WORD}</strong> to confirm:
              </p>
              
              <Input
                placeholder={`Type "${CONFIRM_WORD}" to confirm`}
                value={confirmText}
                onChange={handleConfirmTextChange}
                size="large"
                style={{ 
                  fontFamily: 'monospace',
                  letterSpacing: 2,
                  fontWeight: 'bold'
                }}
                status={confirmText && confirmText !== CONFIRM_WORD ? 'error' : ''}
                prefix={
                  confirmText === CONFIRM_WORD ? 
                    <CheckCircleOutlined style={{ color: '#52c41a' }} /> : 
                    <ExclamationCircleOutlined style={{ color: '#faad14' }} />
                }
                onPressEnter={() => {
                  if (confirmText === CONFIRM_WORD) {
                    onComfirmModelDelete();
                  }
                }}
              />
              
              {confirmText && confirmText !== CONFIRM_WORD && (
                <p style={{ 
                  color: '#ff4d4f', 
                  fontSize: 12, 
                  marginTop: 8,
                  marginBottom: 0 
                }}>
                  Text does not match. Please type exactly "{CONFIRM_WORD}"
                </p>
              )}
              
              {confirmText === CONFIRM_WORD && (
                <p style={{ 
                  color: '#52c41a', 
                  fontSize: 12, 
                  marginTop: 8,
                  marginBottom: 0 
                }}>
                  Confirmation text matched. You can now delete.
                </p>
              )}
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default SkillPage;